<!--
 * @Description: 
 * @Autor: lwq
 * @Date: 2020-08-10 18:20:42
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2020-12-16 16:38:58
 * @FilePath: \mrc-base-server-view\src\views\data-view\add\index.vue
-->
<template>
  <div>
    <data-info @success="success" :loading="loading"></data-info>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { addUpdateViewInfo } from '@/service/api/dataView'
import dataInfo from '../modules/index'
export default {
  components: { dataInfo },
  props: {},
  data() {
    return {
      loading: false,
    }
  },
  validations: {},
  computed: {},
  created() {},
  watch: {},
  mounted() {},

  methods: {
    async success(params, val2) {
      this.loading = true
      try {
        const res = await addUpdateViewInfo({
          ...params,
          mrbase_sys_datamodel_field: val2,
        })
        if (res.code == 200) {
          this.$Message({
            text: this.$t('message_The_operation_was_successful'),
          })
          this.$router.go(-1)
        }
        this.loading = false
      } catch (err) {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped></style>
